import React from 'react'
import Catalog from 'src/modules/Catalog'

const CatalogPage = () => {
  return <Catalog />
}
export default CatalogPage
